// Copyright 2025 Mo-Sys Engineering Ltd. All Rights Reserved.
import React from "react";

export const Error = ({ size, fill, stroke }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 48 48"
      fill={fill || "none"}
      stroke={stroke}
      strokeWidth="2px"
    >
      <circle cx="24" cy="24" r="21.6" />
      <path d="M14,34l20-20-20,20Z" />
      <path d="M34,34L14,14l20,20Z" />
    </svg>
  );
};
